import { render, staticRenderFns } from "./customer-content.vue?vue&type=template&id=e3cc5342&scoped=true&"
import script from "./customer-content.vue?vue&type=script&lang=js&"
export * from "./customer-content.vue?vue&type=script&lang=js&"
import style0 from "./customer-content.vue?vue&type=style&index=0&id=e3cc5342&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cc5342",
  null
  
)

export default component.exports